module.exports = {
  "dof-board": {
    "position": "relative"
  },
  "dof-board-header": {
    "paddingLeft": "32",
    "paddingRight": "32",
    "paddingTop": "32",
    "paddingBottom": "32",
    "backgroundColor": "#f6f7f9"
  },
  "dof-board-header-title": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "36",
    "color": "#1e2e37",
    "fontWeight": "500"
  },
  "dof-board-header-subtitle": {
    "marginTop": "16",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "26",
    "color": "#616c73",
    "fontWeight": "400"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6e4934c3!./~/weex-vue-loader/lib/selector.js?type=styles&index=1!./packages/dof-board/index.vue
// module id = 508
// module chunks = 0 1